import { BaseURl } from "./BaseApiUrl";

//https://testcockpit.p2k.in/api/userdetails/getUserAudioFilesList/v1/?employeeUUID=11efb78d-aaff-58de-9d30-22f17ecb52c5&startDate=05/09/2025&endDate=06/09/2025&isPagination=1&pageNo=1&perPageRec=10
export const getUserAudioRecordingsAPIURL = BaseURl + "userdetails/getUserAudioFilesList/v1/";

//https://testcockpit.p2k.in/api/userdetails/getUserAudioFileTokenForStreaming/v1/?employeeUUID=11efb78d-aaff-58de-9d30-22f17ecb52c5&audioFileUUID=11f08a70-5960-a11c-a6ea-22f17ecb52c5
export const streamUserAudioRecordingAPIURL = BaseURl + "userdetails/getUserAudioFileTokenForStreaming/v1/";

// https://testcockpit.p2k.in/api/userdetails/getUserAudioFileTokenForDownload/v1/?employeeUUID=11efb78d-aaff-58de-9d30-22f17ecb52c5&audioFileUUID=11f08a70-5960-a11c-a6ea-22f17ecb52c5
export const downloadUserAudioRecordingAPIURL = BaseURl + "userdetails/getUserAudioFileTokenForDownload/v1/";
